import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PERMISSION_SUB_MODULES } from '@/shared/const'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PermissionGuard } from '@/shared/ui/permission-guard'
import { DishesWidget } from '@/widgets/dishes-widget'

export const Route = createFileRoute('/_auth/canteen/menu-settings/dishes')({
  staticData: {
    meta: {
      title: 'Перечень блюд',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()

  return (
    <PermissionGuard permission={PERMISSION_SUB_MODULES.MENU_DISHES}>
      <PageWrapper title={t('Перечень блюд')}>
        <DishesWidget />
        <Outlet />
      </PageWrapper>
    </PermissionGuard>
  )
}
